"use client";
import { login } from "@/auth/loginAction";
import Button from "@/components/ui/forms/tailwind/Button";
import Form from "@/components/ui/forms/tailwind/Form";
import Input from "@/components/ui/forms/tailwind/Input";
import PasswordInput from "@/components/ui/forms/tailwind/PasswordInput";
import SubmitButton from "@/components/ui/forms/tailwind/SubmitButton";
import { mapServerErrors } from "@/utils/mapServerErrors";
import { zodResolver } from "@hookform/resolvers/zod";
import Link from "next/link";
import { useRouter, useSearchParams } from "next/navigation";
import { useForm } from "react-hook-form";
import { z } from "zod";

export default function LoginForm() {
  const router = useRouter();
  const schema = z.object({
    username: z.string().min(1, "Dato requerido"),
    password: z.string().min(1, "Dato requerido"),
  });

  const searchParams = useSearchParams();

  const form = useForm<z.infer<typeof schema>>({
    defaultValues: {
      username: "",
      password: "",
    },
    resolver: zodResolver(schema),
  });

  async function handleLogin(data: z.infer<typeof schema>) {
    try {
      const response = await login(data);
      if (response.success) {
        router.push(searchParams.get("next") || "/admin/");
      } else {
        mapServerErrors({ form, errors: response.formErrors });
      }
    } catch (error) {
      form.setError("root.serverError", {
        message:
          "Ha ocurrido un error al intentar iniciar sesión. Por favor, intenta nuevamente.",
      });
    }
  }

  return (
    <>
      <h2 className="wrap-balance my-6 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
        Ingresa al administrador
      </h2>
      <Form methods={form} onSubmit={handleLogin} className="space-y-6">
        {form.formState.errors.root?.serverError && (
          <div className="bg-red-100 p-2 rounded-sm text-red-900">
            {form.formState.errors.root.serverError.message}
          </div>
        )}

        <Input
          name="username"
          autoComplete="username"
          label="Usuario"
          autoCapitalize="off"
          autoCorrect="off"
        />

        <PasswordInput
          name="password"
          label="Contraseña"
          autoComplete="current-password"
        />

        <div className="text-right text-sm leading-4">
          <a
            href="/admin/recuperar-clave"
            className="text-secondary hover:text-secondary font-semibold"
          >
            ¿Olvidaste tu contraseña?
          </a>
        </div>
        <div className="text-right text-sm leading-4">
          <a
            href="/personal"
            className="text-secondary hover:text-secondary font-semibold"
          >
            Ingresar con mi cuenta personal
          </a>
        </div>

        <SubmitButton fullWidth isPending={form.formState.isSubmitting}>
          Ingresar
        </SubmitButton>
      </Form>
    </>
    //   </div>

    //   <div className="hidden p-4 text-center sm:block ">
    //     <p className="mt-10 text-center text-sm text-white">
    //       ¿Necesitas una cuenta?{" "}
    //       <a
    //         href="#"
    //         className="font-semibold leading-6 text-white hover:text-white"
    //       >
    //         Comunicate con nosotros
    //       </a>
    //     </p>
    //     <Image
    //       src={wosm_logo}
    //       alt="World Organization of the Scout Movement"
    //       className="m-auto my-6 h-auto w-32"
    //     />
    //   </div>
    // </div>
  );
}
